




















import {Component, Emit, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import TinyMce from '@/components/admin/TinyMce.vue'
import MessageTemplate from '@/models/MessageTemplate'
import axios from 'axios'
import {apiV1AdminMessageTemplatePath, apiV1AdminMessageTemplatesPath} from '@/rails/routes'

@Component({
  components: {
    TinyMce
  }
})
export default class TemplateEdit extends VueBase {
  @Prop(Object) readonly messageTemplate!: MessageTemplate
  get persisted(): boolean {
    return !!this.messageTemplate.id
  }

  @Emit()
  onCancel(): void {}

  @Emit()
  onSave(): void {}

  async updateTemplate(): Promise<void> {
    if (!this.messageTemplate.title) {
      this.showError('定型文のタイトルを入力してください')
      return
    }
    if (!this.messageTemplate.content) {
      this.showError('本文を入力してください')
      return
    }
    try {
      if (this.persisted) {
        await axios.put(apiV1AdminMessageTemplatePath(this.messageTemplate.id), this.messageTemplate.toParams())
        this.showMessage('定型文の更新が完了しました。')
      } else {
        await axios.post(apiV1AdminMessageTemplatesPath(),this.messageTemplate.toParams())
        this.showMessage('定型文の登録が完了しました。')
      }
      this.onSave()
    } catch (e) {
      console.log(e)
    }
  }
}
